import React, { useEffect } from 'react';
import SafeIcon from '../../common/SafeIcon';

export default function StepExtras({ data, updateData, onNext, onPrev }) {
  const isInsights = data.type === 'insights';
  const isTalent = data.type === 'talenten';
  const isGame = data.type === 'game';

  const isTooShortForProfiles = isInsights && (data.duration === '1u' || data.duration === '2u');

  useEffect(() => {
    if (data.type !== 'insights' && data.type !== 'talenten' && data.type !== 'game') {
      onNext();
    }
    if (isTooShortForProfiles && data.insightsProfiles === 'yes') {
      updateData({ insightsProfiles: 'no' });
    }
  }, [data.type, isTooShortForProfiles, onNext]);

  if (data.type !== 'insights' && data.type !== 'talenten' && data.type !== 'game') {
    return null;
  }

  const isValid = isInsights ? (data.insightsProfiles !== '') : isTalent ? (data.talentTest !== '') : isGame ? (data.gameModule !== '') : true;

  return (
    <div className="space-y-6 animate-fadeIn">
      <h3 className="text-lg font-semibold text-gray-800 mb-4 text-left">5. Specifieke opties voor uw workshop</h3>
      
      {isInsights && (
        <div className="space-y-4">
          <p className="font-medium text-gray-700 text-left">Wenst u persoonlijke Insights profielen?</p>
          {isTooShortForProfiles && (
            <div className="bg-amber-50 border border-amber-200 p-3 rounded-lg flex items-start gap-3 mb-2">
              <SafeIcon name="AlertTriangle" className="text-amber-600 shrink-0 mt-0.5" />
              <p className="text-xs text-amber-800 text-left">
                Voor persoonlijke Insights profielen is een sessie van <strong>minimum een halve dag</strong> vereist om de nodige diepgang te garanderen.
              </p>
            </div>
          )}
          <div className="grid grid-cols-2 gap-3">
            <button
              disabled={isTooShortForProfiles}
              onClick={() => updateData({ insightsProfiles: 'yes' })}
              className={`p-3 rounded-lg border text-center transition-all ${
                data.insightsProfiles === 'yes'
                  ? 'border-[#154A48] bg-white text-[#154A48] font-medium'
                  : isTooShortForProfiles
                  ? 'border-gray-100 bg-gray-50 text-gray-400 cursor-not-allowed'
                  : 'border-gray-200 hover:border-[#154A48]/30'
              }`}
            >
              Ja, incl. materiaal
            </button>
            <button
              onClick={() => updateData({ insightsProfiles: 'no' })}
              className={`p-3 rounded-lg border text-center transition-all ${
                data.insightsProfiles === 'no'
                  ? 'border-[#154A48] bg-white text-[#154A48] font-medium'
                  : 'border-gray-200 hover:border-[#154A48]/30'
              }`}
            >
              Nee, geen profielen
            </button>
          </div>
        </div>
      )}

      {isTalent && (
        <div className="space-y-4">
          <p className="font-medium text-gray-700 text-left">Wenst u een online talententest toe te voegen?</p>
          <div className="grid grid-cols-2 gap-3">
            <button
              onClick={() => updateData({ talentTest: 'yes' })}
              className={`p-3 rounded-lg border text-center transition-all ${
                data.talentTest === 'yes'
                  ? 'border-[#154A48] bg-white text-[#154A48] font-medium'
                  : 'border-gray-200 hover:border-[#154A48]/30'
              }`}
            >
              Ja
            </button>
            <button
              onClick={() => updateData({ talentTest: 'no' })}
              className={`p-3 rounded-lg border text-center transition-all ${
                data.talentTest === 'no'
                  ? 'border-[#154A48] bg-white text-[#154A48] font-medium'
                  : 'border-gray-200 hover:border-[#154A48]/30'
              }`}
            >
              Nee
            </button>
          </div>
        </div>
      )}

      {isGame && (
        <div className="space-y-4">
          <p className="font-medium text-gray-700 text-left">Wenst u de bijhorende online module toe te voegen?</p>
          <div className="grid grid-cols-2 gap-3">
            <button
              onClick={() => updateData({ gameModule: 'yes' })}
              className={`p-3 rounded-lg border text-center transition-all ${
                data.gameModule === 'yes'
                  ? 'border-[#154A48] bg-white text-[#154A48] font-medium'
                  : 'border-gray-200 hover:border-[#154A48]/30'
              }`}
            >
              Ja
            </button>
            <button
              onClick={() => updateData({ gameModule: 'no' })}
              className={`p-3 rounded-lg border text-center transition-all ${
                data.gameModule === 'no'
                  ? 'border-[#154A48] bg-white text-[#154A48] font-medium'
                  : 'border-gray-200 hover:border-[#154A48]/30'
              }`}
            >
              Nee
            </button>
          </div>
        </div>
      )}

      <div className="flex gap-3 pt-4">
        <button
          onClick={onPrev}
          className="px-6 py-3 rounded-lg font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors"
        >
          Terug
        </button>
        <button
          onClick={onNext}
          disabled={!isValid}
          className="flex-1 bg-[#154A48] text-white py-3 rounded-lg font-bold hover:bg-[#0E3432] disabled:opacity-50 transition-colors"
        >
          Volgende stap
        </button>
      </div>
    </div>
  );
}